@if (loading) {
	<div
		class="loading-overlay"
		[ngClass]="includeBackground ? 'loading-overlay-background' : ''"
	>
		<ae-spin-while />
	</div>
}
